import { Page } from '@/core/architecture'

import { ArtistCollectionsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistCollections Page
 * Implemented as a practical sample.
 */
export const ArtistCollections: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ArtistCollectionsTemplate
      state={state}
      onFetchMoreArtistCollection={actions.onFetchMoreArtistCollection}
    />
  )
}
